import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/Elements';
import { Form, InputField } from 'components/Form';
import PropTypes from 'prop-types';
import * as z from 'zod';

import storage from 'utils/storage';
import { useAuth } from 'lib/auth';
import { useState } from 'react';

const schema = z.object({
  otp: z.string().min(1, 'Required'),
});

export const VerifyOTPForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate('/auth/login'); // Redirect to the login page after 5 minutes
    }, 5 * 60 * 1000); // 5 minutes in milliseconds

    return () => clearTimeout(timeout); // Cleanup timeout on component unmount
  }, [navigate]);

  return (
    <div>
      <Form
        onSubmit={async (values) => {
          setLoading(true);
          const phoneNumber = storage.getUserPhoneNumber();
          await login({
            phoneNumber,
            code: values.otp,
          }).catch(() => {
            setLoading(false);
          });
          setLoading(false);
          onSuccess();
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <>
            <InputField
              type="text"
              label="OTP"
              error={formState.errors['otp']}
              registration={register('otp')}
            />
            <div>
              <Button isLoading={loading} type="submit" className="w-full">
                Sign in
              </Button>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

VerifyOTPForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};
